// Home and product pages change on each visit: reviews, recipes, samples and the first partner.
// The product a visitor views most (kept only in their browser) leads the home reviews and recipes.
(() => {
  'use strict';
  const read = (area, key) => { try { return window[area].getItem(key); } catch (e) { return null; } };
  const write = (area, key, value) => { try { window[area].setItem(key, value); } catch (e) {} };

  // One seed per visit: the same order while browsing, a new one next visit
  let seed = Number(read('sessionStorage', 'nl_visit_seed'));
  if (!seed) {
    seed = Math.floor(Math.random() * 2147483646) + 1;
    write('sessionStorage', 'nl_visit_seed', String(seed));
  }
  const random = () => { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };
  const shuffle = list => {
    const items = [...list];
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };

  // Most viewed product (ties go to the most recent)
  let top = '';
  try {
    const views = JSON.parse(read('localStorage', 'nl_views') || '{}');
    top = Object.entries(views).sort((a, b) => b[1].n - a[1].n || b[1].t - a[1].t)[0]?.[0] || '';
  } catch (e) {}
  // Product viewed last (kept only in this browser)
  let last = '';
  try {
    const seen = JSON.parse(read('localStorage', 'nl_views') || '{}');
    last = Object.entries(seen).sort((a, b) => b[1].t - a[1].t)[0]?.[0] || '';
  } catch (e) {}
  // Items for the most viewed product first, everything shuffled
  const order = (items, linked) => {
    const mixed = shuffle(items);
    return top ? [...mixed.filter(linked), ...mixed.filter(item => !linked(item))] : mixed;
  };

  // Reviews: pick this visit's pairs and refill both rows (before the honeycomb starts moving)
  document.querySelectorAll('[data-personalise="reviews"]').forEach(hive => {
    const show = Number(hive.dataset.show) || 12;
    const groups = hive.querySelectorAll('.hive-group');
    const pairs = [...hive.querySelectorAll('.hive-cell--quote[data-pair]')]
      .map(quote => [quote, hive.querySelector(`.hive-cell--photo[data-pair="${quote.dataset.pair}"]`)].filter(Boolean));
    const chosen = order(pairs, ([quote]) => quote.dataset.productId === top).slice(0, show);
    pairs.forEach(pair => pair.forEach(cell => cell.remove()));
    chosen.forEach((pair, index) => pair.forEach(cell => { cell.hidden = false; groups[index % 2].append(cell); }));
  });

  // Recipes: a new random pick on every page load (not the per-visit seed), as many as the section's 'Recipes shown' setting; the rest stay hidden
  document.querySelectorAll('[data-personalise="recipes"]').forEach(section => {
    const grid = section.querySelector('.home-recipes__grid');
    const show = Number(section.dataset.show) || 3;
    [...grid.querySelectorAll('.home-recipe')]
      .map(card => ({ card, key: Math.random() }))
      .sort((a, b) => a.key - b.key)
      .forEach(({ card }, index) => { card.hidden = index >= show; grid.append(card); });
  });

  // Product page recipes and samples: new order each visit (before the slider starts)
  document.querySelectorAll('[data-personalise="extras"]').forEach(section => {
    const track = section.querySelector('.product-extras__track');
    if (!track) return;
    const cards = shuffle(track.children);
    // Combos: cards linked to the product viewed last come first, then only as many as the section shows
    const show = Number(section.dataset.show) || 0;
    const linked = card => last && (card.dataset.products || '').split(' ').includes(last);
    const sorted = show ? [...cards.filter(linked), ...cards.filter(card => !linked(card))] : cards;
    sorted.forEach((card, index) => { if (show && index >= show) card.remove(); else track.append(card); });
  });

  // Partners: start on a different one each visit, once their tabs are ready
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-personalise="partners"]').forEach(section => {
      const tabs = section.querySelectorAll('[data-partner-select]');
      const index = Math.floor(random() * tabs.length);
      if (index > 0) tabs[index].click();
    });
  });
})();
